import i18n from "@/i18n";
import { AclMemberType } from "@/services/security/types";

export const customExtensionsFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];

export const paramsFields = [
    {
        key: "key",
        label: i18n.t("customExtensions.key")
    },
    {
        key: "value",
        label: i18n.t("customExtensions.value")
    },
    {
        key: "actions",
        label: ""
    }
];

export const accessFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "username",
        label: i18n.t("channels.acl.username"),
        sortable: true
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: formatType,
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];

export const addExtensionAccessFields = [
    {
        key: "name",
        label: i18n.t("common.name")
    },
    {
        key: "username",
        label: i18n.t("channels.acl.username")
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: formatType
    },
    {
        key: "access",
        label: ""
    }
];

function formatType(type: AclMemberType) {
    return AclMemberType[type].toString();
}
